(function() {
    'use strict';

    angular.module('user')
        .controller('AdminListController', AdminListController);

    AdminListController.$inject = ['$state', 'adminDataSrvc', 'adminSrvc', 'notificationSrvc', 'adminMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'adminPermissionsConst', 'filterQuerySrvc', 'searchFilterSrvc'];

    function AdminListController($state, adminDataSrvc, adminSrvc, notificationSrvc, adminMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, adminPermissionsConst, filterQuerySrvc, searchFilterSrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.adminRows = [];
        self.adminCols = [{
            title: 'Login',
            value: 'user.username',
            searchable: true,
            orderable: true,
        }, {
            title: 'Imię',
            value: 'user.first_name',
            searchable: true,
            orderable: true,
        }, {
            title: 'Nazwisko',
            value: 'user.last_name',
            searchable: true,
            orderable: true,
        }, {
            title: 'Adres e-mail',
            value: 'user.email',
            searchable: true,
            orderable: true,
        },
        {
            title: 'Data dodania',
            value: 'user.date_added',
            searchable: true,
            orderable: true,
        },
        {
            title: 'Data modyfikacji',
            value: 'user.date_modified',
            searchable: true,
            orderable: true,
        },
        {
            title: 'Data ostatniego logowania',
            value: 'user.auth_token.created',
            searchable: true,
            orderable: true,
        },
        {
            title: 'Edytowano przez',
            value: 'user.last_modified_by',
            searchable: true,
            orderable: true,
        }];
        self.modelPermissions = adminPermissionsConst;

        self.logsInfo = null;

        self.searchQuery = {
            'user.username': null,
            'user.first_name': null,
            'user.last_name': null,
            'user.date_added': null,
            'user.date_modified': null,
            'user.auth_token.created': null,
            'user.last_modified_by': null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.isAllAdmins = isAllAdmins;
        self.filterAllAdmins = filterAllAdmins;
        self.isActiveAdmins = isActiveAdmins;
        self.filterActiveAdmins = filterActiveAdmins;
        self.isInactiveAdmins = isInactiveAdmins;
        self.filterInactiveAdmins = filterInactiveAdmins;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getAdmins();
        }

        function getAdmins(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    is_active: $state.params.is_active,
                    username: self.searchQuery['user.username'],
                    first_name: self.searchQuery['user.first_name'],
                    last_name: self.searchQuery['user.last_name'],
                    email: self.searchQuery['user.email'],
                    date_added: searchFilterSrvc.getDateValue(self.searchQuery['user.date_added']) ,
                    date_modified: searchFilterSrvc.getDateValue(self.searchQuery['user.date_modified']) ,
                    auth_token_created: searchFilterSrvc.getDateValue(self.searchQuery['user.auth_token.created']) ,
                    last_modified_by: searchFilterSrvc.getDateValue(self.searchQuery['user.last_modified_by']),
                    ordering: self.searchQuery.ordering
                };
            }
            return adminDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.adminRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getAdmins);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.admin.create');
        }

        function onEdit(row) {
            $state.go('layout.admin.update', { pk: row.pk });
        }

        function onDelete(row) {
            return adminSrvc.remove(row, function(response) {
                notificationSrvc.notification("success", adminMessagesConst.delete);
                getAdmins();
                return response;
            }, function(response) {
                notificationSrvc.notification(
                    "error", (response.data && response.data[0]) || adminMessagesConst.error);
                return response;
            });
        }

        function isAllAdmins() {
            return $state.params.is_active === undefined;
        }

        function filterAllAdmins() {
            $state.go('layout.admin.list', { is_active: undefined });
        }

        function isActiveAdmins() {
            return $state.params.is_active === '1';
        }

        function filterActiveAdmins() {
            $state.go('layout.admin.list', { is_active: '1' });
        }

        function isInactiveAdmins() {
            return $state.params.is_active === '0';
        }

        function filterInactiveAdmins() {
            $state.go('layout.admin.list', { is_active: '0' });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getAdmins();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getAdmins();
        }
    }
})();
